// saveToDisk.js — force a real disk download for a cross-origin file URL.
//
// `<a download>` is ignored for cross-origin URLs (our SAS links live on
// blob.core.windows.net), so the browser navigates / opens a tab instead of
// saving. Fetching the file and re-serving it as a same-origin object URL
// keeps the download attribute honoured. CORS on the storage account already
// allows GET from the app origin (FilePreview and the report ZIP archive
// fetch the same URLs).

export async function saveUrlToDisk(url, filename) {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`Download failed (${res.status})`);
  const blob = await res.blob();
  const objUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objUrl;
  a.download = filename || 'file';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objUrl);
}
